import { useTheme } from "styled-components";
import AxisConfigsDataTable from "../../../../components/dataTable/tables/AxisConfigsDataTable";
import FormContainer from "../../../../components/formContainer/FormContainer";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import Select from "../../../../components/select/main/Select";

function AxisConfigsPageView({
  axisConfigData,
  onActiveChange,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();
  const theme = useTheme();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="axis_configs_page_fetch">
        <FormContainer
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"axis_configs_page_save"}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.active")}
              required
              error={EVAApiHelper.getResponseError("active", submitError)}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={axisConfigData.active}
                onChange={onActiveChange}
              />
            </InputWrapper>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <AxisConfigsDataTable />
    </StyledFlexColumn>
  );
}

export default AxisConfigsPageView;